import { webApi } from '@mi-front/api-clients';

/**
 * Whether the edit's latest render finished successfully (same rule as the edit card "generated" state).
 */
export function isVideoEditorEditRenderCompleted(
  edit: webApi.EnrichedVideoEditorEditListItemDto,
): boolean {
  return edit.renderJob?.status === 'COMPLETED';
}
